var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentSearch = function SvgDocumentSearch(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 11.7 13",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.667 4.196v6.642A2.174 2.174 0 0 1 9.5 13.004H2.167A2.173 2.173 0 0 1 0 10.838V2.17A2.173 2.173 0 0 1 2.167.004H7.76A.5.5 0 0 1 8.2.171l3.333 3.667a.46.46 0 0 1 .134.358M7.333 1.03l-5.166-.026A1.173 1.173 0 0 0 1 2.171v8.667a1.173 1.173 0 0 0 1.167 1.166H9.5a1.173 1.173 0 0 0 1.167-1.166V4.67H7.833a.507.507 0 0 1-.5-.5zm1 .787 1.699 1.854H8.333z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8.334 10.504 7.02 9.192m.336-1.676a2.012 2.012 0 1 1-4.023 0 2.012 2.012 0 0 1 4.023 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentSearch);
export default ForwardRef;